<template>
  <div
    class="convey-date-picker d-flex align-items-center gap-3 border bg-white-custom pl-3"
    :class="{
      dark: isDarkMode,
      light: !isDarkMode,
      blocked: block,
    }"
  >
    <b-icon icon="calendar2-week-fill"></b-icon>
    <b-input-group>
      <b-input
        type="text"
        readonly
        class="daterange-input pl-0 bg-transparent"
        :value="dateRange"
        :placeholder="placeholder"
      />
    </b-input-group>
  </div>
</template>

<script>
/* eslint-disable */
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import moment from "moment";

export default {
  name: "ConveyDatePicker",
  props: {
    placeholder: String,
    isDarkMode: Boolean,
    block: {
      type: Boolean,
      default: false,
    },
    currentDateRange: null,
  },
  data() {
    return {
      picker: null,
      dateRange: `${moment().startOf("year").format("MM-DD-YYYY")} - ${moment()
        .endOf("year")
        .format("MM-DD-YYYY")}`,
    };
  },
  mounted() {
    this.openDateRangePicker();
  },
  methods: {
    openDateRangePicker() {
      this.picker = $(".daterange-input")
        .daterangepicker(
          {
            opens: "left",
            applyClass: "btn btn-info btn-rounded",
            cancelClass: "btn btn-danger btn-rounded",
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [
                moment().subtract(1, "days"),
                moment().subtract(1, "days"),
              ],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [
                moment().startOf("month"),
                moment().endOf("month"),
              ],
              "This Year": [moment().startOf("year"), moment().endOf("year")],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
            locale: {
              format: "MM-DD-YYYY",
            },
          },
          (start, end) => {
            this.$emit("changeDatePicker", {
              start: start.format("YYYY-MM-DD"),
              end: end.format("YYYY-MM-DD"),
            });
            this.dateRange =
              start.format("MM-DD-YYYY") + " - " + end.format("MM-DD-YYYY");
          }
        )
        .data("daterangepicker");

      if (this.currentDateRange) {
        this.dateRange = `${moment(this.currentDateRange.start_date).format("MM-DD-YYYY")} - ${moment(this.currentDateRange.end_date).format("MM-DD-YYYY")}`;
        this.picker.setStartDate(moment(this.currentDateRange.start_date));
        this.picker.setEndDate(moment(this.currentDateRange.end_date));
      }
    },
  },
  watch: {
    currentDateRange: {
      handler(currentDateRange) {
        if (currentDateRange) {
          if (this.picker) {
            this.dateRange = `${moment(currentDateRange.start_date).format("MM-DD-YYYY")} - ${moment(currentDateRange.end_date).format("MM-DD-YYYY")}`;
            this.picker.setStartDate(moment(currentDateRange.start_date));
            this.picker.setEndDate(moment(currentDateRange.end_date));
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.picker) {
      this.picker.remove();
    }
  },
};
</script>



<style lang="scss">
.convey-date-picker {
  border-radius: 1.5rem;
  width: fit-content;
  &.blocked {
    width: 100%;
  }
  .daterange-input {
    border: none;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    padding-right: 30px;
    background-image: url("../../assets/images/icon/carrot-down-icon.svg");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
  }
  &.dark {
    .daterange-input {
      background-image: url("../../assets/images/icon/carrot-down-icon-white.svg") !important;
    }
  }
}
</style>